import { ForgotPasswordRequest } from "@src/domains/shared/models/Dtos/ForgotPassword";
import { PasswordChangeDto } from "@src/domains/shared/models/Dtos/PasswordChangeDto";
import { ResetPasswordRequest } from "@src/domains/shared/models/Dtos/ResetPassword";
import { UpdateUserProfileDto } from "@src/domains/shared/models/Dtos/UpdateUserProfileDto";
import { AxiosResponse } from "axios";
import { api, ApiRequestConfig } from "../../../app/api/config/api";
import { UserOverview } from "../models/Dtos/userOverview";

const controller = "/account";

export const forgetPassword = async (email: string): Promise<string> => {
  const model: ForgotPasswordRequest = { email: email };
  const url = `${controller}/forget-password`;
  try {
    const result = await api.post<string>(url, model);
    return result.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error("An unknown error occurred"));
  }
};

export const resetPassword = async (
  email: string,
  newPassword: string,
  token: string,
): Promise<string> => {
  const model: ResetPasswordRequest = {
    email: email,
    newPassword: newPassword,
    token: token,
  };
  const url = `${controller}/reset-password`;
  try {
    const result = await api.post<string>(url, model);
    return result.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error("An unknown error occurred"));
  }
};

export const changePassword = async (
  model: PasswordChangeDto,
): Promise<string> => {
  const url = `${controller}/password`;
  try {
    const response: AxiosResponse = await api.put<string>(url, model);
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error("An unknown error occurred"));
  }
};

export const getMe = async (options?: {
  skipAuthRefresh?: boolean;
}): Promise<UserOverview> => {
  const url = `${controller}/me`;
  try {
    const response = await api.get<UserOverview>(url, {
      skipAuthRefresh: options?.skipAuthRefresh ?? false,
    } as ApiRequestConfig);
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error("An unknown error occurred"));
  }
};

export const getUserProfile = async (): Promise<UserOverview> => getMe();

export const updateUserProfile = async (
  model: UpdateUserProfileDto,
): Promise<UserOverview> => {
  const url = `${controller}/profile`;
  try {
    const response = await api.put<UserOverview>(url, model);
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error("An unknown error occurred"));
  }
};
